// Option chips inside filter popups and the edit modal — the same classes the admin customer list and the
// influencer filters use for single-choice options.
export const OPTION_CHIP_CLASS: Record<"selected" | "unselected", string> = {
  selected: "text-primary-dark-solid h-10 rounded-md border-3 p-2 font-bold",
  unselected: "bg-neutral-grey-light h-10 rounded-xl border-0 p-3 text-white",
};

// Outcome chip on the renewal cell when a calendar month is selected: did the customer stay beyond it?
export const RENEWAL_OUTCOME_CHIP_CLASS: Record<"lapsed" | "renewed", string> = {
  lapsed: "bg-danger-light-red text-danger-crimson",
  renewed: "bg-success-light-green text-success-medium-green",
};

// Entitlement chips: on = the plan includes it, off = not included (kept visible so the gap is explicit).
export const ADDON_CHIP_CLASS: Record<"off" | "on", string> = {
  off: "bg-neutral-white-dark text-neutral-grey-light line-through",
  on: "bg-primary-light-solid text-primary-dark-solid",
};

// Billing-source chip beside the plan pill: Stripe checkout or a plan an admin assigned and bills by invoice.
export const SOURCE_CHIP_CLASS = "bg-neutral-white-dark text-neutral-grey-dark";
